import React from 'react'
import OrderListContainer from './OrderListContainer'

export default function OrderListScreen() {
    return <OrderListContainer />
}
